<template>
    <div id="modals-box"></div>
    <ModalConfirm v-if="confirmIsShowed" />

    <template v-for="item in openedModals" :key="item.name">
        <template v-if="modalsComponents[item.name]">
            <component :is="modalsComponents[item.name]" :name="item.name" />
        </template>
    </template>
</template>

<script setup>
import { computed, onBeforeUnmount, defineAsyncComponent, watch } from 'vue';

import ModalConfirm from '🔗/components/modals/ModalConfirm.vue';
import ModalLoader from '🔗/components/modals/ModalLoader.vue';
import ModalSuccess from '🔗/components/modals/ModalSuccess.vue';

import { storeToRefs } from 'pinia';
import stores from '@/stores';

const messengers = stores.messengers();
const modals = stores.modals();

const { openedModals, confirmSettings, modalsComponents } = storeToRefs(modals);

modals.register({
    loader: ModalLoader,
    welcome: defineAsyncComponent(() => import('@/components/modals/ModalWelcome.vue')),
    share: defineAsyncComponent(() => import('@/components/modals/ModalShare.vue')),
    artist: defineAsyncComponent(() => import('@/components/modals/ModalArtist.vue')),
    release: defineAsyncComponent(() => import('@/components/modals/ModalRelease.vue')),
    track: defineAsyncComponent(() => import('@/components/modals/ModalTrack.vue')),
    tracks: defineAsyncComponent(() => import('@/components/modals/ModalTracks.vue')),
    options: defineAsyncComponent(() => import('@/components/modals/ModalOptions.vue')),
    'artist-kebab': defineAsyncComponent(() => import('@/components/modals/ModalArtistKebab.vue')),
    'release-kebab': defineAsyncComponent(() => import('@/components/modals/ModalReleaseKebab.vue')),
    'playlist-kebab': defineAsyncComponent(() => import('@/components/modals/ModalPlaylistKebab.vue')),
    'track-kebab': defineAsyncComponent(() => import('@/components/modals/ModalTrackKebab.vue')),
    'track-lyrics': defineAsyncComponent(() => import('@/components/modals/ModalTrackLyrics.vue')),
    'track-download': defineAsyncComponent(() => import('@/components/modals/ModalTrackDownload.vue')),
    'dict-kebab': defineAsyncComponent(() => import('@/components/modals/ModalDictKebab.vue')),
    gallery: defineAsyncComponent(() => import('🔗/components/modals/ModalGallery.vue')),
    code: defineAsyncComponent(() => import('🔗/components/modals/ModalCode.vue')),
    'merge-accounts': defineAsyncComponent(() => import('@/components/modals/ModalMergeAccounts.vue')),
    'setup-reaction': defineAsyncComponent(() => import('@/components/modals/ModalSetupReaction.vue')),
    success: ModalSuccess
});

const confirmIsShowed = computed(() => !!confirmSettings.value);

watch(
    () => modals.lastIsQueue,
    () => {
        if (modals.lastIsQueue) {
            messengers.showBackButton();
        } else {
            messengers.hideBackButton();
        }
    }
)

onBeforeUnmount(() => {
    modals.unRegister([
        'loader', 'welcome', 'success', 'share', 'artist', 'track', 'tracks', 'gallery',
        'options', 'artist-kebab', 'release', 'release-kebab', 'playlist-kebab',
        'track-kebab', 'track-lyrics', 'track-download', 'dict-kebab',
        'merge-accounts', 'code', 'setup-reaction'
    ]);
});
</script>
